<template>
  <div id="gacha-wrapper">
    <div class="list-wrapper">
      <div class="tab-container">
        <button
          v-for="(tab, i) in tabs"
          :key="i"
          :class="tab.key === selectedTab.key && 'selected'"
          type="button"
          @click="updateSelectedTab(tab)"
        >
          {{ tab.label }}
        </button>
      </div>
      <div class="help-container">
        <img
          @click="showFaq"
          :src="require('@/assets/img/gacha/help-icon.svg')"
          alt=""
        >
        <p @click="showFaq">香の川製麺ガチャって？</p>
      </div>
      <div class="list-container">
        <gacha-list />
      </div>
    </div>
    <error-popup
      v-if="error"
      :title="error.title"
      :message="error.message"
      :label="'閉じる'"
      @submit="clearError"
      @close="clearError"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { GACHA_TAB_TYPE } from '@/store/gacha'
import GachaList from '@/views/Gacha/List.vue'
import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'GachaIndex',
  components: { ErrorPopup, GachaList },
  data() {
    return {
      apiType: '4'
    }
  },
  async created() {
    document.title = '香の川製麺ガチャ取引所'
  },
  computed: {
    ...mapGetters({
      selectedTab: 'Gacha/selectedTab',
      error: 'Gacha/error'
    }),
    tabs() {
      return [GACHA_TAB_TYPE.ticket, GACHA_TAB_TYPE.prize]
    },
    targetTab() {
      let tab = null
      if (this.$route.query.tab === GACHA_TAB_TYPE.ticket.key) {
        tab = GACHA_TAB_TYPE.ticket
      } else if (this.$route.query.tab === GACHA_TAB_TYPE.prize.key) {
        tab = GACHA_TAB_TYPE.prize
      }
      return tab
    }
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Native', [
      'actionRequestToken',
      'actionRequestExternalLink'
    ]),
    ...mapActions('Gacha', ['setSelectedTab', 'setError']),
    updateSelectedTab(tab) {
      this.setSelectedTab(tab)
    },
    openExternalUrl(url) {
      this.actionRequestExternalLink(url)
      // FIXME: for development
      // window.open(url, '_blank')
    },
    showFaq() {
      this.trackEvent(FactoryTrack.createFAQGacha())
      this.$router.push('/faq/gacha')
    },
    clearError() {
      this.setError(null)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none!important;;
  web-kit-appearance: none!important;
  -webkit-tap-highlight-color:rgba(0,0,0,0);

  &:disabled, &.disabled {
    opacity: 0.4;
  }
}

::v-deep .fade-enter-active, ::v-deep .fade-leave-active {
  transition: opacity 0.2s;
}
::v-deep .fade-enter, ::v-deep .fade-leave-to {
  opacity: 0;
}

#gacha-wrapper {
  min-height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    position: fixed;
    top: 0;
    background: #ffffff;
    width: 100%;
    padding-bottom: 10px;
    border-bottom: 1px solid #dddddd;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 16px;
    font-weight: bold;
    color: #222222;
    z-index: 2;

    button {
      width: 44px;
    }
  }

  .list-wrapper {
    flex: auto;
    background: #ffffff;
    display: flex;
    flex-direction: column;

    .tab-container {
      display: flex;
      height: 34px;
      border: 1px solid #66160E;
      background: #66160E;
      margin: 15px 15px 20px;
      border-radius: 4px;
      justify-content: space-around;
      overflow: hidden;

      & > * + * {
        margin-left: 1px;
      }

      button {
        display: block;
        width: 100%;
        background: #ffffff;
        font-weight: bold;
        font-size: 12px;
        color: #5a2200;

        &.selected {
          background: #5a2200;
          color: #ffffff;
        }
      }
    }

    .help-container {
      margin: 5px 20px 20px;
      color: #333333;
      font-size: 13px;
      font-weight: bold;
      text-decoration: underline;
      display: flex;
      justify-content: center;

      & > * + * {
        margin-left: 5px;
      }
    }

    .list-container {
      position: relative;
      text-align: left;
      border-top: 1px solid #dddddd;
      flex: auto;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
